<template>
  <div>
    <div class="position">
      <span
        >您现在的位置：<a href="/">首页</a> > 西安12345政务服务便民热线
        >办件公示</span
      >
      <div>
        <span>
          <a href="/">首页</a>
          <span>/</span>
        </span>
        <span>
          <a>互动</a>
        </span>
      </div>
    </div>
    <div class="container">
      <div class="left">
        <div class="head-box">
          <div class="list-name">诉求列表</div>
          <div class="search-box">
            <el-input
              type="search"
              class="list-search"
              size="small"
              v-model="search"
              placeholder="请输入信件名称关键字"
            />
            <el-button type="primary" class="list-button" round @click="searchList">查询</el-button>
          </div>
        </div>
        <div class="line-box">
          <div class="active-line"></div>
          <div class="line"></div>
        </div>
        <div class="list-content">
          <el-table
            :data="tableData"
            v-loading="loading"
            :header-cell-style="{
              background: '#E9F6FF',
              fontSize: '16px',
              color: '#306BBB',
              fontFamily: 'siyuan',
              fontWeight: 'bold',
            }"
            @row-click="clickRow"
            :row-class-name="tableRowClassName"
          >
            <el-table-column
              prop="orderNo"
              label="诉求编号"
              label-class-name="label-class"
              width="160"
              show-overflow-tooltip
              v-if="!isCollapse"
            >
            </el-table-column>
            <el-table-column
              prop="title"
              label="诉求标题"
              width="220"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="提交时间"
              width="160"
              align="center"
              show-overflow-tooltip
              v-if="!isCollapse"
            >
            </el-table-column>
            <el-table-column
              prop="callbackTime"
              label="回复时间"
              width="160"
              align="center"
              show-overflow-tooltip
              v-if="!isCollapse"
            >
            </el-table-column>
            <el-table-column
              prop="handleDept"
              label="受理部门"
              width="202"
              align="center"
              show-overflow-tooltip
              v-if="!isCollapse"
            >
            </el-table-column>
            <el-table-column
              prop="orderOrigin2Name"
              label="信件来源"
              width="96"
              align="center"
              v-if="!isCollapse"
            >
            </el-table-column>

          </el-table>
          <div class="pagination-box pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="params.pageNum"
              :page-size="10"
              layout="total,prev, next,jumper"
              :total="allSum"
              prev-text="上一页"
              next-text="下一页"
            >
            </el-pagination>
          </div>
          <div class="pagination-box pagination2">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="params.pageNum"
                :page-size="10"
                layout="total,prev, pager, next,jumper"
                :total="allSum"
                prev-text="上一页"
                next-text="下一页"
              >
              </el-pagination>
          </div>
        </div>
      </div>
      <div class="right">
        <hotline />
      </div>
    </div>
  </div>
</template>

<script>
import hotline from "@/components/hotline";
import "@/assets/styles/loc.css";
export default {
  name: "orderList",
  data() {
    return {
      loading:false,
      search: "",
      allSum: 0,
      tableData: [],
      params: {
        title: "",
        pageNum: 1,
        pageSize: 10,
        deptName:''
      },
      currentPage: 1,
      screenWidth:document.body.clientWidth, // 屏幕宽度
      timer: false,
      routeDeptName:''
    };
  },
  components: {
    hotline,
  },
  computed: {
    isCollapse: {
      get () {
        return this.screenWidth < 768
      },
      set () {
      }
    }
  },
  watch: {
    screenWidth (val) {
      if (!this.timer) {
        this.screenWidth = val
        if (this.screenWidth < 768) {
          this.isCollapse = true
        }
        this.timer = true
        let that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }
    }
  },
  methods: {
    searchList(){
      this.params.title =this.search;
      this.params.pageNum = 1;
      this.getList();
    },
    handleSizeChange(val) {
     //分页  size 改变调用
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      // 分页 当前页改变 调用
      this.params.pageNum = val;
      this.getList();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "odd-row";
      } else {
        return "even-row";
      }
    },
    clickRow(row, column, event) {
      sessionStorage.setItem("order-row-public",JSON.stringify(row));
      this.$router.push({
        name: "orderInfoPublic",
        query: {
          orderNo:row.orderNo
        }
      });
    },
    //获取数据
    getList() {
      this.loading = true;
      //this.params.random = this.generateUUID();
      this.params.isPublic = 1;
      // console.log(sessionStorage.getItem("websiteName"));
      if (sessionStorage.getItem("websiteName")){
        this.params.deptName=sessionStorage.getItem("websiteName")
      }
      this.params.deptName = this.routeDeptName
      //this.params.endTime = this.formatDateTime(new Date());
      webAxios
        .get("/seats/caseopen/list", {params:this.params})
        .then((res) => {
            this.loading = false;
          if (res.data.code == 200) {
            this.tableData = res.data.data.records;
            this.allSum = res.data.data.total;
          } else {
            this.tableData = []
            this.allSum = 0
            this.$message({
              type: "info",
              message: "暂无数据",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "查询失败，请刷新后重新尝试！",
          });
          this.loading = false;
        });
    },
    //日期格式化
    dateFormat(row, column, cellValue, index){
        return this.formatDateTime(cellValue)
    },
    //状态格式话
    stateFormat(row, column, cellValue, index){
        return this.formatState(cellValue)
    },
    //编号格式话
    orderFormat(row, column, cellValue, index){
         if(cellValue == ''||cellValue == undefined){
            return "************";
        }else{
            return cellValue;
        }
    }
  },

  created() {
    console.log(this.$route.query);
    
    this.routeDeptName = this.$route.query.dept_name
    this.getList();
    //  this.getUserInfo((res) => {
    //    this.params.telephone = res.callPhone;
    //   this.params.userId = res.callPhone;
    //   this.getList();
    //  });
  },
};
</script>

<style scoped>
@media screen and (max-width: 1200px){
      /* .container{
        position: static;
        padding: 0px;
    } */
}
@media screen and (max-width: 1150px){
    .container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0px;
        padding: 0px;
    }

    body .left{
        width: 95%;
        margin-right:0px;
         padding:0px;
        order: 2;
        /* display: flex; */
        justify-content: center;

    }
    body .right{
        width: 95%;
        order: 1;
        margin-bottom: 15px;
    }
    body .boxCenter {
        display: inline;
        margin-left: 0px;
        padding:0px 10px 20px 40px;
        padding: 52px 36px;

    }
    body .f {
      margin-left: 0px;
    }
    body .search-box .el-input{
        width: 180px;
    }
    body .list-button{
        width: 60px;
    }
    body .list-name{
        font-size: 17px;
    }
    body .pagination2{
        display: none;
    }
    body .pagination{
        display: flex;
    }
}
.container {
  display: flex;
  justify-content: space-between;
}
.left {
  width: 75%;
  /* height: 723px; */
  background: #ffffff;
  flex-flow: row wrap;
  display: flex;
  /* 上下 */
  align-content: space-between;
  margin-right: 20px;
  padding: 0px 23px 0px 23px;
}
.right {
  width: 25%;
}
.head-box {
  width: 100%;
  display: flex;
  height: 62px;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
}
.search-box .el-input__inner {
  height: 30px !important;
}
.search-box .el-input {
  width: 185px;
}
.list-button {
  width: 92px;
  height: 30px;
  background: linear-gradient(0deg, #306bbb, #2d85fd);
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  padding: 6px 0px 10px 0px;
  margin-left: 11px;
}
.list-name {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #306bbb;
  line-height: 52px;
}
.line {
  width: 100%;
  border-bottom: 1px solid #e6e6e6;
  margin: 1px 0 16px;
}
.list-content {
  width: 100%;
  height: 658px;
  background-color: #ffffff;
}
.label-class {
  background-color: #e9f6ff;
}
.pagination-box {
  display: flex;
  justify-content: center;
  border: 1px solid #e3e3e3;
  width: 90%;
  margin: 17px auto 0;
  padding: 5px 0;
}
/* app */
.pagination{
    display: none;
}
.active-line {
  width: 90px;
  height: 3px;
  background: #306bbb;
}
.line-box {
  width: 100%;
  display: flex;
}
</style>
<style>
.el-table .odd-row {
  background: #ffffff;
  cursor: pointer;
}
.el-table .even-row {
  background: #f1f6ff;
  cursor: pointer;
}
.container .cell {
  height: 28px;
}
.el-table__body {
  width: 100% !important;
}
</style>
